<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 49.613 20.785">
    <g id="Truck" transform="translate(0)">
      <path id="Path_86920" data-name="Path 86920"
        d="M1193.934,621.567a4.42,4.42,0,1,0-4.42-4.42,4.424,4.424,0,0,0,4.42,4.42m0-7.035a2.615,2.615,0,1,1-2.615,2.615,2.617,2.617,0,0,1,2.615-2.615"
        transform="translate(-1181.319 -600.781)" :fill="themeColor" />
      <path id="Path_86921" data-name="Path 86921"
        d="M1001.885,621.567a4.42,4.42,0,1,0-4.42-4.42,4.425,4.425,0,0,0,4.42,4.42m0-7.035a2.615,2.615,0,1,1-2.615,2.615,2.618,2.618,0,0,1,2.615-2.615"
        transform="translate(-959.356 -600.781)" :fill="themeColor" />
      <path id="Path_86922" data-name="Path 86922"
        d="M1028.179,551.754a.9.9,0,0,0,.9-.9v-1.6a.9.9,0,0,0-.469-.791l-.706-.387a4.775,4.775,0,0,0-.264-4.128,1.862,1.862,0,0,0-1.5-.873l-10.088-.841-4.544-5.849a.9.9,0,0,0-.713-.349h-8.589a.9.9,0,0,0-.9.9v5.873H981.269a.9.9,0,1,0,0,1.8h20.937a.9.9,0,0,0,.9-.9v-5.873h7.244l4.516,5.813a.9.9,0,0,0,.638.346l10.534.879.051,0a2.957,2.957,0,0,1,.146,2.487.9.9,0,0,0-.3,1.685l1.341.736v1.062a.9.9,0,0,0,.9.9"
        transform="translate(-979.469 -536.037)" :fill="themeColor" />
      <path id="Path_86923" data-name="Path 86923" d="M1091.906,581.338h8.739a.9.9,0,1,0,0-1.8h-8.739a.9.9,0,1,0,0,1.8"
        transform="translate(-1069.169 -572.758)" :fill="themeColor" />
      <path id="Path_86924" data-name="Path 86924"
        d="M1062.406,637.113h16.981a.9.9,0,0,0,0-1.8h-16.981a.9.9,0,0,0,0,1.8" transform="translate(-1043.315 -619.845)"
        :fill="themeColor" />
      <path id="Path_86925" data-name="Path 86925"
        d="M1282.42,590.025a.9.9,0,0,0,.9-.9v-3.145l.634-.634a.9.9,0,0,0,.264-.638v-4.27a.9.9,0,1,0-1.8,0v3.9l-.634.634a.9.9,0,0,0-.264.638v3.519a.9.9,0,0,0,.9.9"
        transform="translate(-1281.518 -572.757)" :fill="themeColor" />
      <path id="Path_86926" data-name="Path 86926" d="M1254.039,637.113h5.319a.9.9,0,1,0,0-1.8h-5.319a.9.9,0,0,0,0,1.8"
        transform="translate(-1253.137 -619.845)" :fill="themeColor" />
    </g>
  </svg>
</template>


<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
